module.exports = __webpack_public_path__ + "static/media/app_configuration.2eae00d6.svg";